import React, { useState, useEffect } from "react";
import { ExternalNavbarButtons, InternalNavbarButtons } from "../components";
import { twMerge } from "tailwind-merge";

const PatchNavbar: React.FC = () => {
  const [isNavbarMenuOpen, setIsNavbarMenuOpen] = useState(false);

  useEffect(() => {
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isNavbarMenuOpen]);

  const handleResize = () => {
    const handleResize = () => {
      if (window.innerWidth > 991 && isNavbarMenuOpen) {
        setIsNavbarMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
  };

  return (
    <div className="fixed left-0 top-0 z-[100]  flex h-[54px] w-full flex-1 items-center border-b border-neutral-600 bg-[#000605] px-5 ">
      <a
        href="https://procomps.gg/"
        className="relative float-left py-[5px] text-[#333] no-underline"
      >
        <img
          src="images/logo_ProComps.png"
          loading="lazy"
          width="148"
          alt=""
          className="mt-0 inline-block max-w-[170px]"
        />
      </a>
      <nav
        role="navigation"
        className="relative ml-5 flex flex-1 items-stretch justify-between max-[991px]:hidden"
      >
        <InternalNavbarButtons variant="navbar" />
        <ExternalNavbarButtons />
      </nav>

      <div
        className={twMerge(
          " absolute top-0 z-30 flex min-h-[200px] w-[calc(100%-38px)] -translate-y-full  transform flex-col items-center justify-start gap-8 bg-neutral-900 py-5 pb-10 transition-all duration-300 min-[991px]:hidden",
          isNavbarMenuOpen ? "top-[54px] translate-y-0 " : "",
        )}
      >
        <InternalNavbarButtons
          variant="navbar"
          className="flex flex-col items-center justify-start gap-8"
        />
        <ExternalNavbarButtons />
      </div>

      <div
        onClick={() => setIsNavbarMenuOpen(!isNavbarMenuOpen)}
        className="relative -mr-5 ml-auto h-[60px] w-[60px] cursor-pointer bg-transparent p-[18px] text-2xl min-[991px]:hidden"
      >
        <img
          src="images/60d5cfaf6fd9b785bd509105_icons8-squared-menu-100.png"
          loading="lazy"
          width="20"
          alt=""
          className="absolute left-1/2 top-1/2 -ml-[10px] -mt-[10px]"
        />
      </div>
    </div>
  );
};

export default PatchNavbar;
